module.exports = __webpack_public_path__ + "static/img/third3_1_2_active.49defc69.jpg";